(() => {
  const styleId = 'polar-scratch-ui-fallback-style';

  if (!document.getElementById(styleId)) {
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      .polar-scratch__intro{text-align:center}.polar-scratch__brand{margin:0;color:rgba(148,231,225,.95);font-weight:900;line-height:1;letter-spacing:0;text-transform:uppercase}.polar-scratch__intro h2{margin:0;color:#fff;font-weight:950;line-height:.98;letter-spacing:0}.polar-scratch__subtitle{max-width:30ch;margin:0 auto;color:rgba(255,255,255,.78);font-weight:650;line-height:1.35}.polar-scratch__value{margin-top:7px;color:#051822;font-size:30px;font-weight:950;line-height:1;letter-spacing:0}.polar-scratch__code{margin:12px 0 8px;padding:8px 16px;border:1px solid rgba(5,24,34,.15);border-radius:999px;background:rgba(255,255,255,.62);font-size:21px}.polar-scratch__manual{display:none!important}.polar-scratch__confetti{position:absolute;inset:0;z-index:5;overflow:hidden;pointer-events:none}.polar-scratch__confetti-piece{position:absolute;top:48%;left:50%;width:8px;height:13px;border-radius:2px;background:var(--color);transform:translate(-50%,-50%) rotate(0deg);animation:polar-scratch-confetti-burst 950ms cubic-bezier(.12,.78,.26,1) forwards}@keyframes polar-scratch-confetti-burst{to{opacity:0;transform:translate(calc(-50% + var(--x)),calc(-50% + var(--y))) rotate(var(--r))}}
      @media screen and (min-width:750px){.polar-scratch__dialog[open]{display:block!important;width:min(540px,calc(100vw - 48px));border-radius:30px}.polar-scratch__shell{padding:58px 44px 34px}.polar-scratch__content{max-width:430px}.polar-scratch__intro{margin-bottom:28px}.polar-scratch__brand{margin-bottom:17px;font-size:21px}.polar-scratch__intro h2{font-size:46px}.polar-scratch__subtitle{margin-top:9px;font-size:17px}.polar-scratch__card{min-height:190px}.polar-footer-section{background:transparent!important;padding-inline:var(--page-margin);padding-block:0 24px}.polar-footer{border-radius:18px;overflow:hidden}}
      @media screen and (max-width:849px){.polar-footer-section{padding-inline:0;padding-block:0}.polar-footer{border-radius:0}.polar-footer__tagline,.polar-footer__column a,.polar-footer__contact span{font-size:13px;line-height:1.45}.polar-footer__column h2{font-size:16px}.polar-footer__column ul{gap:11px}}
      @media screen and (max-width:749px){.polar-scratch__intro{margin-bottom:24px}.polar-scratch__brand{margin-bottom:14px;font-size:17px}.polar-scratch__intro h2{font-size:38px}.polar-scratch__subtitle{margin-top:8px;font-size:15px}}
      @media screen and (max-width:374px){.polar-scratch__intro h2{font-size:34px}.polar-scratch__subtitle{font-size:14px}.polar-footer__bottom small,.polar-footer__bottom span{font-size:11px}}
      @media (prefers-reduced-motion:reduce){.polar-scratch__confetti{display:none}}
    `;
    document.head.appendChild(style);
  }

  const getFallbackOfferValue = (code) => {
    if (String(code).trim().toUpperCase() === 'POLAR50') return '$50 off';
    return 'your discount';
  };

  const getUnlockedStatus = (status, code, offerValue) => {
    const trimmedStatus = String(status || '').trim();
    const trimmedCode = String(code || '').trim();
    const codeText = trimmedCode || 'your code';

    if (!trimmedStatus || trimmedStatus === 'Code unlocked. Tap to copy.') {
      return `Use code ${codeText} for ${offerValue}. Tap to copy.`;
    }

    return trimmedStatus;
  };

  const ensureIntro = (root, card) => {
    const content = root.querySelector('.polar-scratch__content');
    if (!content || !card || content.querySelector('.polar-scratch__intro')) return;

    const intro = document.createElement('div');
    intro.className = 'polar-scratch__intro';
    intro.innerHTML = `
      <p class="polar-scratch__brand">Polar</p>
      <h2>Try Your Luck</h2>
      <p class="polar-scratch__subtitle">Scratch below to reveal your exclusive offer.</p>
    `;
    card.insertAdjacentElement('beforebegin', intro);
  };

  const ensurePrizeValue = (root, offerValue) => {
    const prize = root.querySelector('.polar-scratch__prize');
    const codeButton = root.querySelector('.polar-scratch__code');
    const label = prize?.querySelector('span');

    if (!prize || !codeButton) return;

    if (label && label.textContent.trim().toLowerCase() === 'unlocked code') {
      label.textContent = 'You unlocked';
    }

    if (!prize.querySelector('.polar-scratch__value')) {
      const value = document.createElement('strong');
      value.className = 'polar-scratch__value';
      value.textContent = offerValue;
      codeButton.insertAdjacentElement('beforebegin', value);
    }
  };

  const burstConfetti = (root, dialog) => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const shell = root.querySelector('.polar-scratch__shell') || dialog;
    const existing = shell.querySelector('.polar-scratch__confetti');
    const colors = ['#71d4d0', '#ffd86b', '#ffffff', '#0d9b9a', '#ff8f70'];
    const burst = document.createElement('div');

    if (existing) existing.remove();

    burst.className = 'polar-scratch__confetti';

    for (let index = 0; index < 38; index += 1) {
      const piece = document.createElement('span');
      const angle = (Math.PI * 2 * index) / 38 + Math.random() * 0.5;
      const distance = 92 + Math.random() * 158;
      const x = Math.cos(angle) * distance;
      const y = Math.sin(angle) * distance - 42;

      piece.className = 'polar-scratch__confetti-piece';
      piece.style.setProperty('--x', `${x.toFixed(1)}px`);
      piece.style.setProperty('--y', `${y.toFixed(1)}px`);
      piece.style.setProperty('--r', `${Math.round(Math.random() * 540 - 270)}deg`);
      piece.style.setProperty('--color', colors[index % colors.length]);
      piece.style.animationDelay = `${Math.random() * 110}ms`;
      piece.style.width = `${6 + Math.random() * 5}px`;
      piece.style.height = `${9 + Math.random() * 8}px`;
      burst.appendChild(piece);
    }

    shell.appendChild(burst);
    window.setTimeout(() => burst.remove(), 1400);
  };

  const roots = document.querySelectorAll('[data-polar-scratch-popup]');

  roots.forEach((root) => {
    if (root.dataset.assetInitialized === 'true' || root.dataset.initialized === 'true') return;
    root.dataset.assetInitialized = 'true';
    root.dataset.initialized = 'true';

    const dialog = root.querySelector('.polar-scratch__dialog');
    const closeButtons = root.querySelectorAll('[data-polar-scratch-close]');
    const canvas = root.querySelector('[data-polar-scratch-canvas]');
    const card = root.querySelector('[data-polar-scratch-card]');
    const copyButtons = root.querySelectorAll('[data-polar-scratch-copy]');
    const codeButton = root.querySelector('.polar-scratch__code');
    const status = root.querySelector('[data-polar-scratch-status]');
    const mobileQuery = window.matchMedia('(max-width: 749px)');
    const designMode = root.dataset.designMode === 'true';
    const delay = Math.max(Number(root.dataset.delay || 2), 0) * 1000;
    const threshold = Math.max(Number(root.dataset.revealPercent || 45), 1) / 100;
    const storageKey = root.dataset.storageKey || 'polar_scratch_discount';
    const frequencyHours = Math.max(Number(root.dataset.frequencyHours || 72), 0);
    const scratchLabel = card?.dataset.scratchLabel || 'Scratch to unlock';
    const discountCode = String(codeButton?.dataset.code || copyButtons[0]?.dataset.code || codeButton?.textContent || '').trim();
    const offerValue = String(root.dataset.offerValue || getFallbackOfferValue(discountCode)).trim();
    const unlockedStatus = getUnlockedStatus(root.dataset.unlockedStatus, discountCode, offerValue);
    const copiedStatus = root.dataset.copiedStatus || 'Code copied.';
    const previewParameter = 'polar_scratch_preview';
    const previewMode = (() => {
      if (designMode) return true;

      try {
        const params = new URLSearchParams(window.location.search);
        return params.get(previewParameter) === '1';
      } catch (error) {
        return false;
      }
    })();
    let ctx = null;
    let drawing = false;
    let unlocked = false;
    let pointerId = null;

    if (!dialog || !canvas || !card) return;

    ensureIntro(root, card);
    ensurePrizeValue(root, offerValue);

    const getLocalSuppressedUntil = () => {
      try {
        return Number(window.localStorage.getItem(storageKey) || 0);
      } catch (error) {
        return 0;
      }
    };

    const getCookieSuppressedUntil = () => {
      const encodedKey = `${encodeURIComponent(storageKey)}=`;
      const cookies = document.cookie ? document.cookie.split('; ') : [];
      const cookie = cookies.find((item) => item.indexOf(encodedKey) === 0);

      if (!cookie) return 0;

      return Number(decodeURIComponent(cookie.slice(encodedKey.length)) || 0);
    };

    const getSuppressedUntil = () => Math.max(getLocalSuppressedUntil(), getCookieSuppressedUntil());

    const suppress = () => {
      if (previewMode || frequencyHours <= 0) return;
      const expiresAt = Date.now() + frequencyHours * 60 * 60 * 1000;
      const maxAge = Math.max(Math.ceil((expiresAt - Date.now()) / 1000), 0);

      try {
        window.localStorage.setItem(storageKey, String(expiresAt));
      } catch (error) {
        void error;
      }

      document.cookie = `${encodeURIComponent(storageKey)}=${encodeURIComponent(String(expiresAt))}; Max-Age=${maxAge}; Path=/; SameSite=Lax`;
    };

    const shouldOpen = () => {
      if (previewMode) return true;
      return Date.now() > getSuppressedUntil();
    };

    const lockScroll = () => document.body.classList.add('polar-scratch-is-open');
    const unlockScroll = () => document.body.classList.remove('polar-scratch-is-open');

    const drawOverlay = () => {
      const rect = canvas.getBoundingClientRect();
      const width = Math.max(Math.round(rect.width), 1);
      const height = Math.max(Math.round(rect.height), 1);
      const dpr = Math.max(window.devicePixelRatio || 1, 1);

      canvas.width = Math.round(width * dpr);
      canvas.height = Math.round(height * dpr);

      ctx = canvas.getContext('2d');
      if (!ctx) return;

      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

      const gradient = ctx.createLinearGradient(0, 0, width, height);
      gradient.addColorStop(0, '#8fded9');
      gradient.addColorStop(0.48, '#f1f7f6');
      gradient.addColorStop(1, '#ffd86b');
      ctx.fillStyle = gradient;
      ctx.fillRect(0, 0, width, height);

      ctx.globalAlpha = 0.18;
      ctx.fillStyle = '#051822';
      for (let x = -width; x < width * 2; x += 26) {
        ctx.save();
        ctx.translate(x, 0);
        ctx.rotate(-0.72);
        ctx.fillRect(0, 0, 10, height * 2);
        ctx.restore();
      }
      ctx.globalAlpha = 1;

      ctx.fillStyle = '#051822';
      ctx.font = '900 18px system-ui, -apple-system, BlinkMacSystemFont, sans-serif';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(scratchLabel.toUpperCase(), width / 2, height / 2);
      ctx.globalCompositeOperation = 'destination-out';
    };

    const open = () => {
      if (!shouldOpen()) return;

      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }

      lockScroll();
      suppress();
      window.requestAnimationFrame(drawOverlay);
    };

    const close = () => {
      suppress();
      if (dialog.open && typeof dialog.close === 'function') {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
        unlockScroll();
      }
    };

    const reveal = () => {
      if (unlocked) return;
      unlocked = true;
      root.classList.add('is-unlocked');
      if (status) status.textContent = unlockedStatus;
      burstConfetti(root, dialog);
      suppress();
    };

    const getPoint = (event) => {
      const rect = canvas.getBoundingClientRect();
      return {
        x: event.clientX - rect.left,
        y: event.clientY - rect.top,
      };
    };

    const scratch = (event) => {
      if (!ctx || !drawing || unlocked) return;
      const point = getPoint(event);
      ctx.beginPath();
      ctx.arc(point.x, point.y, 24, 0, Math.PI * 2);
      ctx.fill();
    };

    const getClearedRatio = () => {
      if (!ctx) return 0;
      const pixels = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
      let clear = 0;
      let total = 0;

      for (let index = 3; index < pixels.length; index += 64) {
        total += 1;
        if (pixels[index] < 20) clear += 1;
      }

      return total ? clear / total : 0;
    };

    canvas.addEventListener('pointerdown', (event) => {
      if (unlocked) return;
      drawing = true;
      pointerId = event.pointerId;
      canvas.setPointerCapture(pointerId);
      scratch(event);
    });

    canvas.addEventListener('pointermove', (event) => {
      if (event.pointerId !== pointerId) return;
      scratch(event);
      if (getClearedRatio() >= threshold) reveal();
    });

    const finishScratch = (event) => {
      if (event.pointerId !== pointerId) return;
      drawing = false;
      pointerId = null;
      if (getClearedRatio() >= threshold) reveal();
    };

    canvas.addEventListener('pointerup', finishScratch);
    canvas.addEventListener('pointercancel', finishScratch);
    closeButtons.forEach((button) => button.addEventListener('click', close));

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) close();
    });

    dialog.addEventListener('close', unlockScroll);
    dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      close();
    });

    const handleViewportChange = () => {
      if (dialog.open) window.requestAnimationFrame(drawOverlay);
    };

    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', handleViewportChange);
    } else if (typeof mobileQuery.addListener === 'function') {
      mobileQuery.addListener(handleViewportChange);
    }

    copyButtons.forEach((button) => {
      button.addEventListener('click', async () => {
        const code = button.dataset.code || '';
        if (!code) return;

        try {
          await window.navigator.clipboard.writeText(code);
          if (status) status.textContent = copiedStatus;
        } catch (error) {
          if (status) status.textContent = code;
        }
      });
    });

    window.setTimeout(open, delay);
  });
})();
